<template>
  <div class="social-media-bar">
    <div
      class="image-container"
      v-for="(entity, index) in socialMedia"
      :key="index"
      @click="navigateToSocialMedia(entity.mediaUrl)"
    >
      <v-img class="social-media-image" :src="entity.imageUrl" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMedia",
  data() {
    return {};
  },
  methods: {
    navigateToSocialMedia(url) {
      window.open(url, "_blank");
    },
    shareUrl(entity) {
      const link = window.location.href;
      const message = `Check out this article: ${link}`;
      const encodedMessage = encodeURIComponent(message);
      const platformShareUrl = `${entity.shareUrl}${encodedMessage}`;
      this.navigateToSocialMedia(platformShareUrl);
    },
  },
  computed: {
    socialMedia() {
      return this.whitelabel.socialMedia;
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.social-media-bar {
  margin-top: 32px;
  display: flex;
  width: 100%;
  gap: 20px;
  align-items: center;
  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    cursor: pointer;

    .social-media-image {
      width: 100%;
    }
  }
}
</style>
